import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Vector3 } from 'three';

import { Coordinates } from '../../../../../viewer/utilities/math-helpers';
import { useUnitSymbols } from '../../../../hooks/use-unit-symbols';
import { CoordinatePropertiesStyled } from './coordinate-properties';

export type VolumeInspectorProps = {
  type: 'volume-inspector';
  height: number;
  position: Vector3;
};

export const VolumeInspectorProperties = (props: {
  coordinate: Coordinates;
  coordinateSystem?: string;
  properties: VolumeInspectorProps;
}) => {
  const { t } = useTranslation();
  const unitSymbols = useUnitSymbols();
  return (
    <Component>
      <p className="height">
        <label>
          {t('assetPositionTooltip.volumeInspectorProperties.heightDifference', { ns: 'skyview' })}
        </label>
        <span>
          {props.properties.height.toLocaleString('sv-SE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            signDisplay: 'exceptZero',
          })}{' '}
          {unitSymbols.length}
        </span>
      </p>

      <p className="mas1">
        <label>
          {t('assetPositionTooltip.volumeInspectorProperties.masTargetSurface', {
            ns: 'skyview',
          })}
        </label>
        <span>
          {props.properties.position.z.toLocaleString('sv-SE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}{' '}
          {unitSymbols.length}
        </span>
      </p>

      <p className="mas2">
        <label>
          {t('assetPositionTooltip.volumeInspectorProperties.masSourceSurface', {
            ns: 'skyview',
          })}
        </label>
        <span>
          {(props.properties.position.z + props.properties.height).toLocaleString('sv-SE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}{' '}
          {unitSymbols.length}
        </span>
      </p>
    </Component>
  );
};

const Component = styled(CoordinatePropertiesStyled)`
  grid-template-areas:
    'height             height'
    'mas1               mas2';

  .height {
    grid-area: height;
  }

  .mas1 {
    grid-area: mas1;
  }

  .mas2 {
    grid-area: mas2;
  }
`;
